import React, { ReactNode } from 'react';
import Layout from './Layout';
import { ContactAssignments, PersonProfile, ShortProfile } from 'nekst-api';
import { UserLogoSize } from './Layout/types';

interface AssigneeWidgetProps {
  contactAssignments: ContactAssignments;
}

export function AssigneeWidget(
  props: AssigneeWidgetProps,
) {
  return (
    <Layout
      profile={props.contactAssignments.profile}
      roles={props.contactAssignments.roles}
    />
  );
}
export interface PersonWidgetProps {
  profile: ShortProfile | PersonProfile;
  onClick?: () => void,
  withName?: boolean;
  size?: UserLogoSize;
  badge?: string;
  additionalInfo?: ReactNode | ReactNode[],
}

export function PersonWidget(props: PersonWidgetProps) {
  return (
    <Layout
      profile={props.profile}
      logoSize={props.size}
      badge={props.badge}
      withName={props.withName}
      onClick={props.onClick}
      additionalInfo={props.additionalInfo}
    />
  );
}
